<template>
	<main>
		<div class="wrapper-form">
			<CardForm :card-title="getString('set_password')" :card-body="getString('invited_to_join', [bName])" :cta-text="getString('login_cta')" cta-exists>
				<div>
					<div>
						<AppTextInput type="name" ref="name" :label="getString('name')" :placeholder="getString('name')" @pressed-enter="pressedEnterName" />
					</div>
					<div class="mt-20">
						<AppTextInput type="tel" ref="tel" :label="getString('tel')" :placeholder="getString('tel')" @pressed-enter="pressedEnterTel" />
					</div>
					<div class="mt-20">
						<AppTextInput type="password" ref="password" :label="getString('password')" :placeholder="getString('password')" @pressed-enter="sumbitSignupSpeedy" />
					</div>
					<div class="mt-20">
						<AppButton @click="sumbitSignupSpeedy" :text="getString('login_cta')" :loading="loadingLogin" />
					</div>
				</div>
			</CardForm>
		</div>
	</main>
	<AppNotification ref="invalid-name" :title="getString('error')" :body-text="getString('invalid_name')" :type="-2" />
	<AppNotification ref="invalid-tel" :title="getString('error')" :body-text="getString('invalid_phone')" :type="-2" />
	<AppNotification ref="password-too-short" :title="getString('error')" :body-text="getString('password_too_short')" :type="-2" />
	<AppNotification ref="mail-verification-error" :title="getString('error')" :body-text="getString('mail_verification_error')" :type="-2" />
</template>

<script>

import {useLanguageStore} from "@/shared/stores";
import langObject from "@/console-signup-speedy/assets/json/langs.json";
import langObjectAuto from "@/console-signup-speedy/assets/json/auto.json";
import API from "@/shared/helpers/API";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import CardForm from "@/console-reset/components/CardForm.vue";
import AppNotification from "@/shared/components/AppNotification.vue";
import {validatePhone} from "@/shared/helpers/strings";

export default {
	components: {AppButton, AppTextInput, CardForm, AppNotification},
	setup() {
		const languageStore = useLanguageStore();
		return {languageStore, getString: languageStore.getString};
	},
	name: "App",
	data() {
		return {
			loadingLogin: false,
		}
	},
	computed: {
		bName() {
			if(typeof businessName !== "undefined") {
				return businessName;
			} else {
				return this.getString("a_business");
			}
		},
	},
	methods: {
		pressedEnterTel(value) {
			if(this.$refs && this.$refs['password'] && validatePhone(value)) {
				this.$refs['password'].focus()
			} else {
				this.$refs["invalid-tel"].openNotification();
			}
		},
		pressedEnterName(value) {
			if(this.$refs && this.$refs['tel'] && value.length > 1) {
				this.$refs['tel'].focus()
			}
		},
		sumbitSignupSpeedy() {
			let name = this.$refs['name'].currentValue;
			if(name.length < 2) {
				this.$refs["invalid-name"].openNotification();
				return;
			}
			let tel = this.$refs.tel.currentValue;
			if(validatePhone(tel)) {
				let password = this.$refs['password'].currentValue;
				if(password.length > 7) {
					this.loadingLogin = true;
					API.init().verifyCodeSpeedy(code, tel, password, name, (response) => {
						if(response && response.result === "OK") {
							sessionStorage.setItem("oauth_token", response.oauth_token);
							localStorage.setItem("refresh_token", response.refresh_token);
							window.location.replace(URL_HTML+"/console/new/");
						} else {
							this.$refs["mail-verification-error"].openNotification();
						}
					});
				} else {
					this.$refs["password-too-short"].openNotification();
				}
			} else {
				this.$refs["invalid-tel"].openNotification();
			}

		},
	},
	created() {
		this.languageStore.addStrings(langObject, "signup-speedy", langObjectAuto);
		API.init(URL_HTML, URL_HTML+"/console/login/");
	},
}
</script>

<style lang="scss" scoped>
	main {
		background-color: #f9fafd;
		.wrapper-form {
			position: relative;
			width: 100%;
			min-height: 100vh;
			padding: 40px 20px 80px;
			display: flex;
			justify-content: center;
			align-items: center;
			@media(max-width: 300px) {
				padding: 12px;
			}
		}
	}
</style>